
//retrieve cookie 
function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}
//erase cookie
function setCookie(name,value,days) {
  var expires = "";
  if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

// Apply styling to cart to aknowledge discount has been applied
function applyCartDiscountStyles() {
  if(document.body.contains(document.querySelector('[data-cart-total]'))) {
    var cartTotals = document.querySelectorAll("[data-cart-total]");
    //Array.from(cartTotals, elm => elm.setAttribute('style', 'text-decoration: line-through; color:#ff7992'));
    Array.from(cartTotals, elm => elm.firstElementChild.setAttribute('style', 'color: black'));
    var other = document.querySelector(".cart-title-total");
    var sub = document.querySelector(".cart-final-total")
    const span = document.createElement("span");
    span.innerText = "Quiz bundle discount applied at checkout";
    const span2 = document.createElement("span");
    span2.innerText = "Quiz bundle discount applied at checkout";
    other.appendChild(span);
    sub.prepend(span2);
    var quizMessageArr = [span, span2];
    quizMessageArr.map(elm => {elm.setAttribute('style', 'font-size: .75rem; color:#ff7992'); elm.setAttribute('data-quiz-spin-text', '')});
  } else {
    setTimeout(() => {
      
    }, "250");
  }
}

//function to remove styling to cart to aknowledge discount has been applied
var stylesApplied = false;
function removeStyles() {
  document.querySelectorAll('[data-quiz-spin-text]').forEach(elm => elm.remove());
}


// Observer to handle discounts after canvas and before checkout flow
function handleCartDiscounts() {
  if(document.body.contains(document.querySelector('.cartitems--list'))) {
	var currentPrice = document.querySelector('[data-html="cart_total"]');
    const spinDisc = getCookie('digioh_coupon');
    const quizThresholds = getCookie('mb_quiz_disc_thresholds');
    var quizDisc;
    var mbDiscount;

    //Function to set appropriate discount
    function setDiscount() {
    var sanitizedTotal = parseInt(document.querySelector('[data-cart-total]').innerText.replace(/[^a-zA-Z0-9 ]/g, ''));
      //If the cart is not empty and the user came from the quiz flow
      if (sanitizedTotal > 1 && quizThresholds) {
        //Parse cookie into an array of objects
        var discArray = JSON.parse(quizThresholds)
        discArray = discArray.filter((obj) => parseInt(obj.threshold) <= sanitizedTotal);
       //Set initial value for max discount and loop over array to end with the max discount to be set
        var max_discount = discArray[0];
        discArray.forEach(obj => {
          obj.threshold > max_discount.threshold ? max_discount = obj : max_discount = max_discount;
        })
        //If the array is empty apply no discount else set the discount code
        quizDisc = !discArray.length ? "No-Discount" : max_discount.code;
        mbDiscount = quizDisc;
        //User has visited both quiz and the spin but the quiz discount resulted in no discount
        if (spinDisc && !mbDiscount.includes('QUIZ')) {
          mbDiscount = spinDisc;
          applyDiscount(mbDiscount);
        //User only visitied the quiz
        } else {
          applyDiscount(mbDiscount);
        }
      }
      //User only visitied the spin
      else if (sanitizedTotal > 1 && spinDisc) {
        if (mbDiscount == null || !mbDiscount.includes('QUIZ')) {
          mbDiscount = spinDisc;
          applyDiscount(mbDiscount);
        }
      } 
    } 

	  var cartObserver = new MutationObserver(mutated);
	  var cartConfig = { childList: true, subtree: true, };
	  function mutated() {
        setDiscount();
	  }
	  setDiscount();
	  cartObserver.observe(currentPrice, cartConfig);
  }
  else {
	setTimeout(() => {
	  handleCartDiscounts();
	}, "250");
  }
};


//Function to apply discount
function applyDiscount(disc) {
  fetch(`/discount/${disc}`)
  .then((response) => {
    if(response.ok == true){
      if(stylesApplied == true && getCookie('discount_code') == 'No-Discount'){
        removeStyles();
        stylesApplied = false;
      }
      if(stylesApplied == false && getCookie('discount_code') != 'No-Discount'){
        applyCartDiscountStyles(); 
        stylesApplied = true;
      }
    }
    if(response.ok == false){
      console.log(response.error()); 
      if(getCookie('discount_code') == null || getCookie('discount_code') == 'No-Discount'){
        removeStyles();
        stylesApplied = false;
      }
    }
  });
}
handleCartDiscounts();

